import { css, styled, TextV1, Theme } from '@withjoy/joykit';
import { DefaultToastContainer } from 'react-toast-notifications';
import { SharedToastProps, ToastStatus, ToastTransitionStates, ToastVariant } from './Toast.type';
import { TOAST_TRANSFORMS } from './Toast.constants';

const toastColor = (theme: Theme) => ({
  error: '#C50020',
  warning: '#FFBA00',
  general: theme.colors.primary6
});

export const StyledToastWrapper = styled.div`
  background-color: ${props => props.theme.colors.mono14};
  border-radius: 12px;
  padding: 24px;
`;

export const StyledDefaultToastContainer = styled(DefaultToastContainer)`
  max-width: 477px;
`;

export const StyledToastText = styled(TextV1)`
  color: ${props => props.theme.colors.white};
`;

export const ToastIcon = styled.div`
  svg {
    width: 32px;
    height: 32px;
  }
`;

export const ToastWrapper = styled.div<{ status: ToastStatus; variant: ToastVariant }>`
  display: flex;
  min-width: 300px;
  max-width: 477px;
  margin: 1rem;
  padding: 32px;
  border-radius: 32px 32px 16px 16px;
  ${({ variant }) => {
    if (variant === 'toast') {
      return css`
        position: fixed;
        left: 0;
        bottom: 0;
      `;
    } else {
      return css`
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
      `;
    }
  }}

  ${({ status, theme }) => {
    if (status === 'error') {
      return css`
        background: #fff7f8;
        border: 1px solid #ffe6ea;
      `;
    } else if (status === 'warning') {
      return css`
        background: ${theme.colors.info1};
        border: 1px solid #fff3e6;
      `;
    } else {
      return css`
        background: ${theme.colors.humana1};
        border: 1px solid #fff2e8;
      `;
    }
  }}
  ${ToastIcon} {
    color: ${({ status, theme }) => toastColor(theme)[status]};
  }
`;

export const ToastContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const getTransitionStates = (shared: SharedToastProps): ToastTransitionStates => {
  const transforms = TOAST_TRANSFORMS[shared.$variant];
  return {
    from: {
      opacity: 0,
      transform: transforms.out
    },
    to: shared.$isOpen
      ? {
          opacity: 1,
          transform: transforms.in
        }
      : {
          opacity: 0,
          transform: transforms.out
        }
  };
};
